import type { Banner, PageInfo } from '@@partner:types:app'
import type {
  CommonPager,
  NestedFilter,
  CommonSort
} from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import {
  SHORTCUT_PAGE_INFO_FIELDS,
  SHORTCUT_BANNERS_FIELDS
} from '@@partner:graphql/shortcuts'

export interface AllBannersQuery {
  allBanners: {
    edges: Banner[]
    pageInfo: PageInfo
  }
}
export interface AllBannersQueryVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager: CommonPager
}

export const GQL_QUERY_ALL_BANNERS = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allBanners (
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
    edges {
      ${SHORTCUT_BANNERS_FIELDS}
    }
    pageInfo {
      ${SHORTCUT_PAGE_INFO_FIELDS}
    }
  }
}
`

export const useFetchAllBanners = (variables: AllBannersQueryVariables) =>
  useQuery<AllBannersQuery, AllBannersQueryVariables>(GQL_QUERY_ALL_BANNERS, {
    variables,
    fetchPolicy: 'cache-and-network'
  })
